import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AppStoreProvider } from "@/lib/store";
import { SiteContentProvider } from "@/lib/siteContent";
import { Toaster } from "sonner";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import CartDrawer from "@/components/CartDrawer";
import PredictiveSearch from "@/components/PredictiveSearch";
import MobileBottomNav from "@/components/layout/MobileBottomNav";
import HomePage from "@/pages/Home";
import ShopPage from "@/pages/Shop";
import ProductPage from "@/pages/Product";
import QuizPage from "@/pages/Quiz";
import DiscoveryBuilderPage from "@/pages/DiscoveryBuilder";
import CheckoutPage from "@/pages/Checkout";
import OrderConfirmedPage from "@/pages/OrderConfirmed";
import AccountPage from "@/pages/Account";
import LoginPage from "@/pages/Login";
import RegisterPage from "@/pages/Register";
// Static / marketing / legal pages
import AboutPage from "@/pages/static/About";
import CraftPage from "@/pages/static/Craft";
import SourcingPage from "@/pages/static/Sourcing";
import SustainabilityPage from "@/pages/static/Sustainability";
import GiftingPage from "@/pages/static/Gifting";
import FAQPage from "@/pages/static/FAQ";
import ContactPage from "@/pages/static/Contact";
import TrackOrderPage from "@/pages/static/TrackOrder";
import JournalPage from "@/pages/static/Journal";
import CareGuidePage from "@/pages/static/CareGuide";
import PressKitPage from "@/pages/static/PressKit";
import LoyaltyPage from "@/pages/static/Loyalty";
import SubscriptionsPage from "@/pages/static/Subscriptions";
import GiftCardsPage from "@/pages/static/GiftCards";
import GiftCardBalancePage from "@/pages/static/GiftCardBalance";
import WholesalePage from "@/pages/static/Wholesale";
import ShippingPage from "@/pages/static/Shipping";
import ReturnsPage from "@/pages/static/Returns";
import PrivacyPage from "@/pages/static/Privacy";
import TermsPage from "@/pages/static/Terms";
import CookiesPage from "@/pages/static/Cookies";
import AccessibilityPage from "@/pages/static/Accessibility";
import DoNotSellPage from "@/pages/static/DoNotSell";
import { AuthProvider } from "@/lib/auth";
import "@/App.css";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function Shell() {
  return (
    <div className="min-h-screen flex flex-col bg-[#FAF8F5] text-[#1A1918]" data-testid="app-shell">
      <Header />
      <div className="flex-1 pb-[72px] md:pb-0">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/product/:slug" element={<ProductPage />} />
          <Route path="/quiz" element={<QuizPage />} />
          <Route path="/discovery-builder" element={<DiscoveryBuilderPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/order-confirmed/:orderId" element={<OrderConfirmedPage />} />
          <Route path="/account" element={<AccountPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          {/* Static / marketing / legal pages */}
          <Route path="/about" element={<AboutPage />} />
          <Route path="/craft" element={<CraftPage />} />
          <Route path="/sourcing" element={<SourcingPage />} />
          <Route path="/sustainability" element={<SustainabilityPage />} />
          <Route path="/gifting" element={<GiftingPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/track-order" element={<TrackOrderPage />} />
          <Route path="/journal" element={<JournalPage />} />
          <Route path="/care-guide" element={<CareGuidePage />} />
          <Route path="/press" element={<PressKitPage />} />
          <Route path="/loyalty" element={<LoyaltyPage />} />
          <Route path="/subscriptions" element={<SubscriptionsPage />} />
          <Route path="/gift-cards" element={<GiftCardsPage />} />
          <Route path="/gift-cards/balance" element={<GiftCardBalancePage />} />
          <Route path="/wholesale" element={<WholesalePage />} />
          <Route path="/shipping" element={<ShippingPage />} />
          <Route path="/returns" element={<ReturnsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/cookies" element={<CookiesPage />} />
          <Route path="/accessibility" element={<AccessibilityPage />} />
          <Route path="/do-not-sell" element={<DoNotSellPage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </div>
      <Footer />
      <MobileBottomNav />
      <CartDrawer />
      <PredictiveSearch />
      <Toaster position="top-center" toastOptions={{ style: { background: "#FAF8F5", border: "1px solid rgba(197,160,89,0.4)", color: "#1A1918" } }} />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppStoreProvider>
          <SiteContentProvider>
            <ScrollToTop />
            <Shell />
          </SiteContentProvider>
        </AppStoreProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
